<template>
    <main
        class="font-(family-name:(--primary-font)) min-h-screen flex flex-col justify-center p-6 relative overflow-hidden">
        <div class="absolute inset-0 z-0 bg-black">
            <div
                class="absolute inset-0 bg-[linear-gradient(to_bottom,rgba(0,0,0,0.8),rgba(0,0,0,0.4),rgba(0,0,0,0.9))]"></div>
        </div>
        <slot />
    </main>
</template>

<script setup lang="ts">
    import { BRAND } from '@constants/common';
    import { formatPageTitle } from '@utils/formatter';

    useHead({ title: formatPageTitle(BRAND, 'Login') });
</script>
